import { Component, OnInit } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import {IMeta, MetaService} from "@shared/services/web/meta.service";
import {BreadcrumbsService} from "@shared/services/web/breadcrumbs.service";

@Component({
  selector: 'app-aviso-legal',
  templateUrl: './aviso-legal.component.html',
  styleUrls: ['./aviso-legal.component.scss'],
})
export class AvisoLegalComponent implements OnInit {
  constructor(
    private translateService: TranslateService,
    private metaService: MetaService,
    private breadcrumbsService: BreadcrumbsService
  ) {
    this.changeMeta();
    this.setBreadcrumb();
  }

  changeMeta() {
    const meta: IMeta = {
      language: this.translateService.currentLang,
      title: 'aviso_legal',
      description: 'aviso_legal_desc',
    };
    this.metaService.changeMeta(meta);
  }

  ngOnInit(): void {
    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.changeMeta();
    });
  }

  setBreadcrumb() {
    this.breadcrumbsService.setBreadcrumb([
      { label: 'Inicio', label_en: 'Home', path: '/' },
      { label: 'Aviso legal', label_en: 'Legal Notice', path: null },
    ]);
  }
}
